import { CSSProperties } from 'react';

import { OutcomesFieldOption } from 'types';

export const outcomeCardClassName =
  'flex items-center gap-2 rounded-[12px] border-[1.5px] border-green-primary bg-white py-4 pl-4 pr-2 shadow-[0px_4px_8px_0px] shadow-blue-shadow10 md:pl-2 md:pr-4';

export const outcomeCardDraggingOverlayClassName =
  'cursor-grabbing shadow-[0px_8px_16px_0px] shadow-blue-shadow16';

export const outcomeCardDefaultClassName = 'cursor-grab';

export const buildOrderedOutcomes = (
  outcomes: OutcomesFieldOption[],
  orderedIds: string[]
) => {
  if (!outcomes.length) {
    return [];
  }

  const positionById = new Map(orderedIds.map((id, index) => [id, index]));

  return [...outcomes].sort((left, right) => {
    const leftPosition = positionById.get(left.id);
    const rightPosition = positionById.get(right.id);

    if (leftPosition === undefined && rightPosition === undefined) {
      return 0;
    }
    if (leftPosition === undefined) {
      return 1;
    }
    if (rightPosition === undefined) {
      return -1;
    }
    return leftPosition - rightPosition;
  });
};

export const moveOutcome = (
  outcomes: OutcomesFieldOption[],
  activeId: string,
  overId: string
) => {
  const activeIndex = outcomes.findIndex((item) => item.id === activeId);
  const overIndex = outcomes.findIndex((item) => item.id === overId);

  if (activeIndex === -1 || overIndex === -1 || activeIndex === overIndex) {
    return outcomes;
  }

  const next = [...outcomes];
  const [moved] = next.splice(activeIndex, 1);
  next.splice(overIndex, 0, moved);

  return next;
};

export const getTransformStyle = (
  transform?: { x: number; y: number; scaleX: number; scaleY: number } | null
): CSSProperties['transform'] =>
  transform
    ? `translate3d(${transform.x}px, ${transform.y}px, 0) scaleX(${transform.scaleX}) scaleY(${transform.scaleY})`
    : undefined;
